var angular = require('angular')
var langCs = require('./i18n/cs.js').cs
var langEn = require('./i18n/en.js').en
var uiMask = require('angular-ui-mask')

angular.module('OwInputAccountNumberCmp', [uiMask])
  .component('owInputAccountNumber', {
    template: require('./ow-input-account-number.component.tpl.html'),
    controller: OwInputAccountNumberController,
    controllerAs: 'vm',
    bindings: {
      formField: '<',
      value: '<',
      onChanged: '&'
    }
  })

OwInputAccountNumberController.$inject = ['i18n']

function OwInputAccountNumberController (i18n) {
  var vm = this

  vm.$onInit = function () {
    i18n.appendLangFile('cs', langCs)
    i18n.appendLangFile('en', langEn)
    vm.prefix = ''
    vm.accountNumber = vm.value || ''
    vm.bankCode = ''
    vm.uiOptions = {
      clearOnBlur: false,
      maskDefinitions: { '9': /\d/ }
    }
    vm.mask = '999999-?9?9?9?9?9?9?9?9?9?9/?9?9?9?9'
    vm.maskPlaceholder = '000000-__________/____'

    vm.onChange = onChange
    vm.pasteFunction = pasteFunction
    vm.isAccountValid = isAccountValid
  }

  vm.$onChanges = function (changesObj) {
    if (changesObj.formField) {
      vm.type = getType()
    }
    if (changesObj.value) {
      vm.accountNumber = changesObj.value
    }
  }

  function getType () {
    if (vm.formField.hidden) {
      return 'hidden'
    } else {
      return 'tel'
    }
  }

  function setAccount () {
    var prefix = vm.fullAccount.substr(0, 6)
    var accountNumber = vm.fullAccount.substr(6, 10)
    var bankCode = vm.fullAccount.substr(16, 4)
    var validAccount = prefix + '-' + accountNumber + '/' + bankCode
    vm.onChanged({ value: validAccount, formFieldId: vm.formField.id })
  }

  function isAccountValid () {
    return (isValidAccountPrefix() && isValidAccountNumber() && isValidBankCode())
  }

  function isValidAccountPrefix () {
    var prefix = vm.prefix
    return (10 * prefix[0] + 5 * prefix[1] + 8 * prefix[2] + 4 * prefix[3] + 2 * prefix[4] + 1 * prefix[5]) % 11 === 0
  }

  function isValidAccountNumber () {
    var accountNumber = vm.accountNumber
    return (
      6 * accountNumber[0] +
      3 * accountNumber[1] +
      7 * accountNumber[2] +
      9 * accountNumber[3] +
      10 * accountNumber[4] +
      5 * accountNumber[5] +
      8 * accountNumber[6] +
      4 * accountNumber[7] +
      2 * accountNumber[8] +
      1 * accountNumber[9]) % 11 === 0 && accountNumber !== '0000000000'
  }

  function isValidBankCode () {
    var bankCode = vm.bankCode
    var regexp = RegExp('^[0-9]{4}$')
    return (regexp.test(bankCode) && bankCode !== '0000')
  }

  function pasteFunction (event) {
    var text = event.clipboardData ? event.clipboardData.getData('text/plain') : event.originalEvent.clipboardData.getData('text/plain')
    var regex1 = RegExp('^[0-9]{1,6}-[0-9]{1,10}/[0-9]{4}$')
    var regex2 = RegExp('^[0-9]{1,10}/[0-9]{4}$')
    var regex3 = RegExp('^[0-9]{1,10}$')
    var isAccountFull = (regex1.test(text))
    var isAccountWithBank = (regex2.test(text))
    var isAccountOnly = (regex3.test(text))

    var indexDash = text.indexOf('-')
    var indexSlash = text.indexOf('/')

    var item1 = '0'
    var item2 = '0'
    var item3 = '0'

    if (isAccountFull) {
      item1 = text.substr(0, indexDash)
      item2 = text.substring(indexDash + 1, indexSlash)
      item3 = text.substr(indexSlash + 1)
    } else if (isAccountWithBank) {
      item2 = text.substring(0, indexSlash)
      item3 = text.substr(indexSlash + 1)
    } else if (isAccountOnly) {
      item2 = text
    } else {
      vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('paste_account_format', false)
    }

    vm.prefix = item1.padStart(6, '0')
    vm.accountNumber = item2.padStart(10, '0')
    vm.bankCode = item3.padStart(4, '0')
    vm.fullAccount = vm.prefix + vm.accountNumber + vm.bankCode
    onChange()
  }

  function setValidity () {
    var account = vm.fullAccount

    vm.prefix = account.substr(0, 6)
    vm.accountNumber = account.substr(6, 10)
    vm.bankCode = account.substr(16, 4)

    vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('account_number', isValidAccountNumber())
    vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('account_prefix', isValidAccountPrefix())
    vm['form_' + vm.formField.id]['field_' + vm.formField.id].$setValidity('bank_code', isValidBankCode())
  }

  function onChange () {
    setValidity()
    if (isAccountValid()) {
      setAccount()
    }
  }
}
